/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	addToCartErrored,
	addToCartSucceeded,
	addToCartTriggered,
	atcSnackbarClosed,
	atcSuccessDrawerClosed,
	atcSuccessDrawerOpened,
	fbtAddToCartErrored,
	fbtAddToCartSucceeded,
	inventoryExceeded,
	inventoryNotExceeded,
	quantityRangeValidationFailed,
	quantityRangeValidationSucceeded,
	userSetFulfillmentOption,
	userSetInputQuantity,
	warrantyAddToExistingCartErrored
} from './add-to-cart.actions';
import { AddToCartState } from '@pdp/data-access/interfaces';

export const atcFeatureKey = 'atc';

// declare what the values should be upon starting the application
export const initialAddToCartState: AddToCartState = {
	userInputQuantity: '1',
	fulfillmentOption: 'shipToMe',
	buttonAction: 'add to cart',
	success: null,
	// eslint-disable-next-line max-len
	airballMessage:
		"Your product missed the cart. We're sorry, please refresh your page and add to cart again. If the problem persists, please let us know.",
	isLoading: false,
	isMultipleProducts: false,
	inventoryExceededStatus: {
		inventoryExceeded: false
	},
	maxOrMinQuantityAlert: null,
	warrantyAddToExistingCartError: false
};

export const addToCartReducers = createReducer(
	initialAddToCartState,
	on(userSetInputQuantity, (state, action) => {
		return {
			...state,
			userInputQuantity: action.atcUserInputQuantity
		};
	}),
	on(userSetFulfillmentOption, (state, action) => {
		return {
			...state,
			fulfillmentOption: action.atcFulfillmentOption
		};
	}),
	on(addToCartSucceeded, (state) => {
		return {
			...state,
			success: true,
			isLoading: false,
			isMultipleProducts: false
		};
	}),
	on(addToCartErrored, (state) => {
		return {
			...state,
			success: false,
			isLoading: false,
			isMultipleProducts: false
		};
	}),
	on(atcSnackbarClosed, atcSuccessDrawerClosed, (state) => {
		return {
			...state,
			success: null,
			isLoading: false,
			isMultipleProducts: false
		};
	}),
	on(fbtAddToCartSucceeded, (state) => {
		return {
			...state,
			success: true,
			isLoading: false,
			isMultipleProducts: true
		};
	}),
	on(fbtAddToCartErrored, (state) => {
		return {
			...state,
			success: false,
			isLoading: false,
			isMultipleProducts: true
		};
	}),
	on(addToCartTriggered, (state) => {
		return {
			...state,
			isLoading: true
		};
	}),
	on(inventoryExceeded, (state, action) => ({
		...state,
		inventoryExceededStatus: {
			inventoryExceeded: true,
			maxInventory: action.maxInventory
		},
		userInputQuantity: `${action.maxInventory}`
	})),
	on(inventoryNotExceeded, (state) => ({
		...state,
		inventoryExceededStatus: {
			inventoryExceeded: false
		}
	})),
	on(quantityRangeValidationFailed, (state, action) => ({
		...state,
		maxOrMinQuantityAlert: action.message
	})),
	on(quantityRangeValidationSucceeded, (state, action) => ({
		...state,
		maxOrMinQuantityAlert: null
	})),
	on(warrantyAddToExistingCartErrored, (state) => ({
		...state,
		warrantyAddToExistingCartError: true
	})),
	on(atcSuccessDrawerOpened, (state) => ({
		...state,
		warrantyAddToExistingCartError: false
	}))
);
